import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { ErrorMessage } from "@/components/ui/States";
import AdminPwaMeta from "@/components/admin/AdminPwaMeta";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        api.get("/admin/auth/me").then(() => navigate("/admin", { replace: true })).catch(() => {});
    }, [navigate]);

    const submit = async (e) => {
        e.preventDefault();
        setError(null);
        setSubmitting(true);
        try {
            await api.post("/admin/auth/login", { email: email.trim().toLowerCase(), password });
            navigate("/admin", { replace: true });
        } catch (err) {
            setError(err?.response?.data?.detail || "Login failed.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[var(--color-bg-alt)] px-4">
            <AdminPwaMeta />
            <div className="a1-card max-w-md w-full" data-testid="admin-login-card">
                <h1 className="serif text-2xl mb-1">A1 Screening — Admin</h1>
                <p className="serif italic text-sm text-[var(--color-text-muted)] mb-6">"From pool cages to condos, we screen it all."</p>
                <form onSubmit={submit} className="grid gap-3" noValidate>
                    <div>
                        <label className="a1-label" htmlFor="al-email">Email</label>
                        <input id="al-email" type="email" className="a1-input" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" data-testid="admin-login-email" />
                    </div>
                    <div>
                        <label className="a1-label" htmlFor="al-password">Password</label>
                        <input id="al-password" type="password" className="a1-input" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" data-testid="admin-login-password" />
                    </div>
                    {error ? <ErrorMessage message={error} testId="admin-login-error" /> : null}
                    <button type="submit" className="a1-btn-primary" disabled={submitting} data-testid="admin-login-submit">
                        {submitting ? "Signing in…" : "Sign in"}
                    </button>
                </form>
            </div>
        </div>
    );
}
